import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  // SEC-P3: read JWT from sessionStorage (AuthContext writes it here).
  // Fallback to the legacy `neighborli_token` key so any pre-migration tab
  // keeps working until it's reloaded.
  let token = null;
  try {
    token = sessionStorage.getItem('token') || localStorage.getItem('neighborli_token');
  } catch { /* storage unavailable */ }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
export const API = API_BASE;
